export default {
    path: '/taskPanel/wholeTaskPanel',
    name: 'WholeTaskPanel',
    component: () => import(/* webpackChunkName: "wholeTaskPanel" */ '../../views/taskPanel/components/wholeTaskPanel.vue')
}